import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import { graphqlOperation, API } from '@aws-amplify/api'
import awsconfig from '@/auth/aws-exports'
import config from '@/config'
import Store from '@/stores/'

export const configureEndpoint = async (authToken) => {
  const params = new URL(document.location).searchParams
  const urlToken = params.get('token')

  try {
    awsconfig.API = {
      graphql_endpoint: config.GRAPHQL_TRANSFORMATION_LAYER,
      graphql_headers: async () => {
        return {
          Authorization: authToken || urlToken || (await Auth.currentSession()).getIdToken().getJwtToken(),
        }
      },
    }

    Amplify.configure(awsconfig)
  } catch (err) {
    console.error('Error getting the current session', err)
  }
}

const handleGraphQLErr = async (err) => {
  if (!err) {
    return
  }
  if (err.errors && err.errors[0] && err.errors[0].message && err.errors[0].message.match(/401|custom:clientId/)) {
    try {
      Store.dispatch('User/wipeUser')
      await Auth.signOut()
    } catch (err) {
      console.error('[ERROR] - Unacceptable error, logging out the application for security reasons', err)
    }
  }
  throw err
}

const parseAndThrowError = async (obj, customErrorHandler) => {
  let error

  if (Array.isArray(obj?.errors) && obj.errors.length > 0) {
    error = obj.errors[0]
  } else if (typeof obj === 'object') {
    error = obj
  } else {
    error = new Error('Unknown error occurred')
  }

  try {
    return customErrorHandler ? await customErrorHandler(error) : await handleGraphQLErr(error)
  } catch (e) {
    return Promise.reject(e)
  }
}

export const useGraphQL = async (
  operation,
  parameters = {},
  { customResHandler = null, customErrorHandler = null } = {},
) => {
  await configureEndpoint()
  try {
    const response = await API.graphql(graphqlOperation(operation, parameters))

    if (customResHandler) {
      const throwError = customResHandler.check(response)
      if (throwError) {
        throw new Error(customResHandler.message)
      }
    }

    // Errors that come from the GraphQL API itself - Validation errors etc
    if (response.errors || response.error) {
      return parseAndThrowError(response, customErrorHandler)
    }

    return { response }
  } catch (err) {
    // Exception-level errors such as network errors
    if (API.isCancel(err)) {
      console.error('User cancelled the request', err.message) // "my message for cancellation"
    }

    return parseAndThrowError(err, customErrorHandler)
  }
}
